/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Events_By_TimeInputs */

const en_order_events_by_time = /** @type {(inputs: Order_Events_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order Events by Time`)
};

const fr_order_events_by_time = /** @type {(inputs: Order_Events_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trier les événements par temps`)
};

const de_order_events_by_time = /** @type {(inputs: Order_Events_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisse nach Zeit sortieren`)
};

const it_order_events_by_time = /** @type {(inputs: Order_Events_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordina gli eventi per ora`)
};

const ru_order_events_by_time = /** @type {(inputs: Order_Events_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сортировать события по времени`)
};

const es_order_events_by_time = /** @type {(inputs: Order_Events_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar eventos por tiempo`)
};

const zh_cn2_order_events_by_time = /** @type {(inputs: Order_Events_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按时间排序事件`)
};

const ja_order_events_by_time = /** @type {(inputs: Order_Events_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時間順にイベントを並べ替える`)
};

const hi_order_events_by_time = /** @type {(inputs: Order_Events_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समय के अनुसार घटनाओं को क्रमबद्ध करें`)
};

const pt_pt2_order_events_by_time = /** @type {(inputs: Order_Events_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar eventos por horário`)
};

/**
* | output |
* | --- |
* | "Order Events by Time" |
*
* @param {Order_Events_By_TimeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const order_events_by_time = /** @type {((inputs?: Order_Events_By_TimeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Events_By_TimeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_order_events_by_time(inputs)
	if (locale === "de") return de_order_events_by_time(inputs)
	if (locale === "it") return it_order_events_by_time(inputs)
	if (locale === "ru") return ru_order_events_by_time(inputs)
	if (locale === "es") return es_order_events_by_time(inputs)
	if (locale === "zh-CN") return zh_cn2_order_events_by_time(inputs)
	if (locale === "ja") return ja_order_events_by_time(inputs)
	if (locale === "hi") return hi_order_events_by_time(inputs)
	if (locale === "pt-PT") return pt_pt2_order_events_by_time(inputs)
	return en_order_events_by_time(inputs)
});